// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout___nc-0","footer":"Layout_footer__1AOx9","footer--collapsed":"Layout_footer--collapsed__1DXsr","innerLayout":"Layout_innerLayout__1_IJw"};